import React from 'react';
import { urlFor } from '../../sanity'; // Adjust the import path based on your project structure

export const renderBlockContent = (blocks) => {
  return blocks?.map((block) => {
    switch (block._type) {
      case 'block':
        const { style = 'normal', children } = block;
        return (
          <p className={`text-${style}`} key={block._key}>
            {children.map((child) => {
              return (
                <span key={child._key} className={child.marks.includes('strong') ? 'font-bold' : ''}>
                  {child.text}
                </span>
              );
            })}
          </p>
        );

      case 'image':
        return <img src={urlFor(block.asset).url()} alt={block.alt} key={block._key} />;

      case 'list':
        return (
          <ul key={block._key}>
            {block.listItems.map((item) => (
              <li key={item._key}>{item.text}</li>
            ))}
          </ul>
        );

      default:
        return null; // Handle unknown block types
    }
  });
};